import { takeLatest, put, call, select } from 'redux-saga/effects';

import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

import { 
    GET_TICKETS_DETAILS_REQUEST, 
    getTicketsDetailsSuccess, 
    getTicketsDetailsFailure,

} from '../actions/ticketsDetails';

import { getTicketsDetailsService } from '../services/ticketsDetails';

export const getTicketDetailsWorker = function* (){
    try {

        const token = yield select(accessTokenSelector);
        const { data: { tasksCasesDetails } } = yield call(getTicketsDetailsService, token);

        yield put(getTicketsDetailsSuccess(tasksCasesDetails));
        
    } catch (err) {
        const { data: errorData } = err.response;

        yield put(getTicketsDetailsFailure(err));
        yield put(showGlobalError(true, errorData?.statusCode, errorData?.message));
    }
}

export default [
    takeLatest(GET_TICKETS_DETAILS_REQUEST, getTicketDetailsWorker),
]